requestAnimationFrame(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    const HOST = 'product-lists-toggle-button';

    function findVariantInput(root) {
      let form = root.closest?.('product-form');
      if (form?.querySelector('input[name="id"], select[name="id"]')) return form.querySelector('input[name="id"], select[name="id"]');
      form = root.closest?.('form[action*="/cart/add"]');
      if (form?.querySelector('input[name="id"]')) return form.querySelector('input[name="id"]');
      const inRoot = root.querySelector?.('input[name="id"]');
      if (inRoot) return inRoot;
      const section = root.closest?.('[id^="product-"], section, .product, .card, .page-width') || document;
      return section.querySelector('input[name="id"]');
    }
    const parseVid = (val) => {
      const n = Number(String(val || '').trim());
      return Number.isFinite(n) && n > 0 ? n : null;
    };

    class ProductListsToggleButton extends HTMLElement {
      constructor() {
        super();
        this.list = (this.dataset.list || 'compare').toLowerCase();
        this.button = this.querySelector('button');
        this.handle = this.getAttribute('handle') || '';
        this._variantInput = null;
        this._initialSynced = false;
        this._boundOnChange = this.onVariantChange.bind(this);
        this._boundCoreChange = this.onCoreChange.bind(this);
        this._boundClick = this.onClick.bind(this);
      }
      connectedCallback() {
        this._variantInput = findVariantInput(this);
        this._currentVid = this._variantInput ? parseVid(this._variantInput.value) : parseVid(this.getAttribute('variant-id'));
        this._variantInput?.addEventListener('change', this._boundOnChange);
        this.button?.addEventListener('click', this._boundClick);
        document.addEventListener('product-lists:change', this._boundCoreChange);

        if (window.ProductLists?.ready) {
          window.ProductLists.ready.then(() => {
            this._initialSynced = true;
            this.syncVisual(true);
          }).catch(() => {});
        }
      }
      disconnectedCallback() {
        this._variantInput?.removeEventListener('change', this._boundOnChange);
        document.removeEventListener('product-lists:change', this._boundCoreChange);
        this.button?.removeEventListener('click', this._boundClick);
      }
      get vid() {
        return this._variantInput ? parseVid(this._variantInput.value) : parseVid(this._currentVid);
      }
      onVariantChange() {
        const nv = this.vid;
        if (nv && nv !== this._currentVid) {
          this._currentVid = nv;
          this.syncVisual(false);
        }
      }
      onCoreChange(e) {
        try {
          const list = (e.detail?.list || e.detail?.listName || '').toLowerCase();
          if (list && list !== this.list) return;
        } catch {}
        this.syncVisual(false);
      }
      onClick(e) {
        const vid = this.vid;
        if (!vid || !this.handle || !window.ProductLists || !this.button) return;
        if (this.button.classList.contains('loading')) return;

        const wasActive = this.button.classList.contains('active');
        this.button.classList.add('loading');
        if (wasActive) this.button.classList.add('removing');

        return Promise.resolve()
          .then(() => wasActive ?
            window.ProductLists.remove(this.list, vid, this.handle) :
            window.ProductLists.add(this.list, vid, this.handle)
          )
          .then(() => this.syncVisual(false))
          .catch((error) => {
            console.error('Unable to update the product list.', error);
            this.button.classList.toggle('active', wasActive);
          })
          .finally(() => {
            this.button.classList.remove('loading', 'removing');
          });
      }
      syncVisual(respectSSR) {
        const vid = this.vid;
        if (!vid || !this.handle || !window.ProductLists || !this.button) return;
        if (respectSSR && !this._initialSynced) return;
        const inList = window.ProductLists.has(this.list, vid, this.handle);
        this.button.classList.toggle('active', !!inList);
      }
    }
    if (!customElements.get(HOST)) customElements.define(HOST, ProductListsToggleButton);
  });
});
